<template>
  <StatusCard
    :cor="card.situacao.cor"
  >
    <div style="display:flex; flex-flow: row nowrap;">
      <ExtratoItem
        :row="card"
        style="flex: 1;"
      />
      <StatusItem
        :column=" { field: 'situacao', title: 'Situação' }"
        :row="card"
        style="flex: 0.5; position: relative; top: 10px"
      />
      <DataItem
        :column="{ field: 'data_registro', title: 'Data solicitação' }"
        :row="card"
        style="flex: 0.5; position: relative; top: 10px"
      />
      <MoedaItem
        :column="{ field: 'valorSolicitado', title: 'Valor Solicitado' }"
        :row="card"
        style="flex: 0.5; position: relative; top: 10px"
      >
      </MoedaItem>
      <MoedaItem
        :column="{ field: 'valorReembolsado', title: 'Valor Liberado' }"
        :row="card"
        style="flex: 0.5; position: relative; top: 9px"
      >
      </MoedaItem>
      <AcoesWidget v-if="showWidgetActions" :row="card" :preloadWidget="preloadWidget"/>
    </div>
  </StatusCard>
</template>
<script>
import DataItem from '@/components/listagemColumn/DataItem.vue'
import ExtratoItem from '@/components/listagemColumn/ExtratoItem'
import StatusCard from '@/components/cards/StatusCard'
import StatusItem from '@/components/listagemColumn/StatusItem'
import MoedaItem from '@/components/Listagem/floatItem'
import AcoesWidget from '@/components/TemplateSolicitacao/componentes/AcoesWidget.vue'

export default {
  name: 'ListaExtratoCard',
  components: { AcoesWidget, MoedaItem, DataItem, ExtratoItem, StatusCard, StatusItem },
  props: {
    card: {},
    showWidgetActions: {
      type: Boolean,
      default: false
    },
    preloadWidget: {
      type: Function
    }
  }
}
</script>
